export default function getQueryFilter(queryParams, param, filterOption) {
  if (queryParams[param]) {
    const filters = queryParams[param].split('|');
    const fullFilter = filters.find(filter => {
      const [filterKey] = filter.split(':');
      return filterKey === filterOption;
    });

    if (fullFilter) {
      const [, filterValue] = fullFilter.split(':');
      return {
        fullFilter,
        filterOption,
        filterValue,
      };
    }
    return null;
  }
}
